import React, { useEffect } from "react";
import awsconfig from "./config/aws-exports.js";
import { InitData } from "./config/InitData";
import { getCurrentAuthentication } from "./config/authentication/AuthService";

// Custom Pre-Auth Components
import LoginScreen from "./containers/Login.js";
import Amplify from "@aws-amplify/core";
import Analytics from "@aws-amplify/analytics";
import { Authenticator } from "aws-amplify-react";
import { Hub, Auth } from "aws-amplify";
import App from "./App.js";

Analytics.disable();

Amplify.configure(awsconfig);

// Local variables
let intervalID;

function AppWithAuth(props) {
  useEffect(() => {
    Hub.listen("auth", ({ payload }) => {
      switch (payload.event) {
        case "signIn":
        case "tokenRefresh":
        case "verifyContact":
          setTimeout(async () => {
            InitData.getInstance().setOnAuthState("signIn");
            updateUser();
          }, 900000);
          break;
        case "signOut":
          console.log("signOut -");
          InitData.getInstance().setOnAuthState("signOut");
          break;
        case "signUp":
          console.log("user signed up");
          break;
        default:
          console.log("Not a valid payload event");
          break;
      }
    });
    // initial state when Auth does not call the listener
    updateUser();
    return function cleanup() {
      clearInterval(intervalID);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateUser = () => {
    try {
      getCurrentAuthentication();
      intervalID = setInterval(() => {
        // console.log("Setting interval ID");
      }, 900000); // 15 min
    } catch (err) {
      console.log("Failed to authenticate user");
    }
  };

  const handleLogOut = () => {
    console.log("handling log out");
    Auth.signOut();
  };

  return (
    <Authenticator amplifyConfig={awsconfig} hideDefault={true}>
      <LoginScreen />
      <App />
    </Authenticator>
  );
}
export default AppWithAuth;
